import { collectionEngineV1 } from '../apis.js';
const billingAppendixSetupsAPI = collectionEngineV1('/billing-appendix-setups');
export const del = (id) => billingAppendixSetupsAPI('DELETE', `/${id}`);
export const patch = (id, patch) => billingAppendixSetupsAPI('PATCH', `/${id}`, {
    body: patch,
});
export const get = () => billingAppendixSetupsAPI('GET', `/`);
export const create = (newBillingAppendixSetup) => billingAppendixSetupsAPI('POST', `/`, {
    body: newBillingAppendixSetup,
});
//# sourceMappingURL=billing-appendix-setups.js.map